export default "__VITE_ASSET__Ily8oHlz__"